import template from './description.html';
import controller from './description.controller';
import './description.scss';

let descriptionComponent = {
  bindings: {
    item: "=",
    language: "<",
    model: "<",
    modelName: "<"
  },
  template,
  controller,
  controllerAs: "vm"
};

export default descriptionComponent;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/description/description.component.js